import { FC, useState, ChangeEvent, useEffect } from 'react';
import { useStyles } from './styles';
import { Grid, Paper, Tabs, Tab, IconButton } from '@material-ui/core';
import TabPanel from 'components/TabPanel';
import { GenericForm } from './SubForms';
import { useHistory } from 'react-router-dom';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import { handleCompanyUrl } from 'utils/organizationUtils';
import { useStore } from 'hooks/useRootStore';
import { useQuery } from 'react-query';
import Timeline from 'components/Timeline';
function a11yProps(index: string) {
  return {
    id: `wrapped-tab-${index}`,
    'aria-controls': `wrapped-tabpanel-${index}`,
  };
}

export const UserForm: FC<any> = ({ type }) => {
  const classes = useStyles();
  const [value, setValue] = useState<string>('one');
  const history = useHistory();
  const {
    ldapStore: { getUserTimeline },
    notificationStore: { openNotification },
  } = useStore();
  const [currentUser, setCurrentUser] = useState<any>(
    history.location.pathname.split('/')[3] === 'add'
      ? localStorage.removeItem('ClickedUser')
      : JSON.parse(localStorage.getItem('ClickedUser') as string)
  );
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setCurrentUser(JSON.parse(localStorage.getItem('ClickedUser') as string));
    }, 3000);

    // Clean up the timeout when the component unmounts to avoid memory leaks
    return () => clearTimeout(timeoutId);
  }, []);

  const handleChange = (event: ChangeEvent<unknown>, newValue: string) => {
    setValue(newValue);
  };
  const timelineReq = useQuery(
    ['userTimeline', currentUser?.user_id],
    () => getUserTimeline(currentUser?.user_id || currentUser?.id || ''),
    {
      enabled: value === 'two' && type === 'view',
      onError: () => {
        openNotification('error', `Can't get user timeline`);
      },
    }
  );
  return (
    <Grid item xl className={classes.tabsPanel}>
      <Paper className={classes.tabsPaper}>
        <div className={classes.left}>
          <IconButton
            onClick={() => {
              history.push(handleCompanyUrl('/users'));
            }}
          >
            <ChevronLeftIcon />
          </IconButton>
          <Tabs
            value={value}
            indicatorColor='secondary'
            textColor='secondary'
            onChange={handleChange}
            className={classes.tabs}
          >
            <Tab
              value='one'
              label={currentUser?.uid ? `User: ${currentUser.uid}` : 'USER'}
              {...a11yProps('one')}
              className={classes.label}
            />
            {type === 'view' && <Tab value='two' label={'Timeline'} {...a11yProps('one')} className={classes.label} />}
          </Tabs>
        </div>
        <div className={classes.tabBox}>
          <TabPanel value={value} index='one'>
            <GenericForm type={type} currentUserData={currentUser} />
          </TabPanel>
          {type === 'view' && (
            <TabPanel value={value} index='two'>
              <Timeline header='user' events={timelineReq.data || []} loading={timelineReq.isLoading} />
            </TabPanel>
          )}
        </div>
      </Paper>
    </Grid>
  );
};
